import { useEffect, useState } from "react";

type LoadingProps = {
  message: string;
  className?: string;
};

export function Loading({ message, className = "" }: LoadingProps) {
  const [dots, setDots] = useState<string>(".");

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length === 3 ? "." : prev + "."));
    }, 300);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`flex justify-start items-center bg-main top-0 left-0 ${className}`}>
      <p className="min-w-fit">{message}</p>
      <p className="min-w-[50px]">{message && dots}</p>
    </div>
  );
}
